<template>
    <footer class="o-footer footer">
        <!--<ABackButton
            v-if="isShowBackButton"
            tag="button"
            :text="$t('ui.home')"
            theme="home"
        /> -->
        <ABackButton
            v-if="isShowBackButton"
            tag="button"
            :text="$t('ui.back')"
            route="start"
        />
        <OServicesButtons v-if="isShowServicesButton "/>
        <MVersions />
        <ACompanyInfo />
    </footer>
</template>

<script>
import MVersions from '../../molecules/m-versions/m-versions';
import ABackButton from '../../atoms/a-back-button/a-back-button';
import ACompanyInfo from '../../atoms/a-company-info/a-company-info';
import OServicesButtons from '../../organisms/o-services-buttons/o-services-buttons';

import {
    START_SCREEN,
    GUIDE_SCREEN
} from '../../../utils/constants/pages';

export default {
    name: "OFooter",
    components: {
        ABackButton,
        ACompanyInfo,
        OServicesButtons,
        MVersions
    },
    computed: {
        isShowBackButton() {
            return ![GUIDE_SCREEN, START_SCREEN].includes(this.$route.name);
        },
        isShowServicesButton() {
            return this.$route.name.includes(START_SCREEN);
        }
    }
}
</script>

<style lang="scss">
@import "o-footer";
</style>
